import { render, staticRenderFns } from "./Error403ForbiddenView.vue?vue&type=template&id=4d7c6758&"
import script from "./Error403ForbiddenView.vue?vue&type=script&lang=ts&"
export * from "./Error403ForbiddenView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports